//import router from '@/router'
import { apiGetData } from '@/services/ApiService.js'
import { Buffer } from 'buffer'

const state = () => ({
  rememberMe: false,
  auth: false,
  sysHref: {
    bpo: '',
    confidence: '',
    adm: '',
    auth: '',
    store: '',
    home: '',
  },
  sysHrefMap: new Map(),
  user: {},
  entity: {},
  instance: {},
  roots: [],
  rootsGlobals: [],
  systems: [],
})

const actions = {
  async refreshUser({ commit }) {
    await apiGetData('auth/login/get-active-session').then((response) => {
      commit('LOAD_SYS_HREF', response)
      if (response?.sessionState) {
        commit('LOAD_SESSION', response)
        commit('INIT_SESSION')
      }
    })
  },
  async recoverSession({ commit }) {
    commit('REMEMBER_STATE_RECOVER')

    await apiGetData('auth/login/get-active-session')
      .then((response) => {
        // Sempre processa sysHref, mesmo se response for vazio
        commit('LOAD_SYS_HREF', response)

        if (response?.sessionState) {
          commit('LOAD_SESSION', response)
          commit('INIT_SESSION')
        } else {
          commit('END_SESSION')
        }
      })
      .catch(() => {
        // Em caso de erro da API (página pública)
        commit('LOAD_SYS_HREF', null)
        commit('END_SESSION')
      })
  },

  setRememberState({ commit }, state) {
    commit('SET_REMEMBER_STATE', state)
  },

  logout({ commit }) {
    apiGetData('auth/login/revoke')
    commit('END_SESSION')
  },

  endSession({ commit }) {
    commit('END_SESSION')
  },

  async fetchSysHref({ commit }) {
    const response = await apiGetData('auth/login/get-sys-href')
      .then((response) => {
        commit('LOAD_SYS_HREF', response)
      })
      .catch(() => {
        commit('LOAD_SYS_HREF', null)
      })
  },
}

const mutations = {
  LOAD_SYS_HREF(state, response) {
    // Se página pública ou API não enviou sysHref
    if (!response || !response.sysHref) {
      state.sysHref = {
        bpo: '',
        confidence: '',
        adm: '',
        auth: '',
        store: '',
        home: '',
      }

      state.sysHrefMap.clear()
      return
    }

    // Se veio sysHref válido
    state.sysHref = response.sysHref

    state.sysHrefMap.clear()
    for (const sys in state.sysHref) {
      state.sysHrefMap.set(state.sysHref[sys], sys)
    }
  },

  LOAD_SESSION(state, response) {
    state.user = response.user || {}
    state.entity = response.entity || {}
    state.instance = response.instance || {}
    state.roots = response.roots || []
    state.rootsGlobals = response.rootsGlobals || []
    state.systems = response.systems || []

    localStorage.setItem('user', JSON.stringify(state.user))
  },

  INIT_SESSION(state) {
    state.auth = true
  },

  END_SESSION(state) {
    if (!state.rememberMe) {
      localStorage.removeItem('user')
    }

    state.auth = false

    // Se não há sysHref.auth → página pública
    if (!state.sysHref?.auth) {
      console.warn('END_SESSION: Página pública, sem redirect.')
      return
    }

    const currentPath = window.location.pathname

    // Evita loop: já está no login
    if (
      currentPath.startsWith('/login') ||
      currentPath.startsWith('/users/login')
    ) {
      console.warn('END_SESSION: Já está na página de login, evitando loop.')
      return
    }

    // Monta domínio atual
    let domain = `${window.location.protocol}//${window.location.hostname}`
    if (window.location.port) {
      domain = `${domain}:${window.location.port}`
    }

    // Encontra o sys correspondente
    let sys = state.sysHrefMap.get(domain)

    // Se sys não existir → não redireciona
    if (!sys) {
      console.warn(
        'END_SESSION: sys não encontrado para o domínio atual. Evitando loop.'
      )
      return
    }

    // Redirecionamento válido
    const buffer = Buffer.from(`${sys}:/${window.location.pathname}`)
    window.location.replace(
      `${state.sysHref.auth}/users/login/${buffer.toString('base64')}`
    )
  },

  SET_REMEMBER_STATE(state, status) {
    state.rememberMe = status
    localStorage.setItem('rememberMe', status)
  },

  REMEMBER_STATE_RECOVER(state) {
    try {
      state.rememberMe = JSON.parse(localStorage.getItem('rememberMe'))

      state.user = localStorage.getItem('user')
        ? JSON.parse(localStorage.getItem('user'))
        : {}
    } catch (e) {
      state.rememberMe = false
      state.user = {}
    }
  },
}

const getters = {
  getSessionState: (state) => state,
  getAuthStatus: (state) => state.auth,
  getRememberMeState: (state) => state.rememberMe,
  getUser: (state) => state.user,
  getEntity: (state) => state.entity,
  getInstance: (state) => state.instance,
  getSysHref: (state) => state.sysHref,
  getRoots: (state) => state.roots,

  checkGlobal: (state) => (root) =>
    state.rootsGlobals.filter((segment) => segment == root).length > 0,

  checkGlobals: (state, getters) => (roots) => {
    let access = false
    roots.forEach((element) => {
      if (getters.checkGlobal(element)) access = true
    })
    return access
  },

  checkRoot: (state) => (root) =>
    state.roots.filter((segment) => segment == root).length > 0,

  checkRoots: (state, getters) => (roots) => {
    let access = false
    roots.forEach((element) => {
      if (getters.checkRoot(element)) access = true
    })
    return access
  },

  getSystems: (state) => state.systems,

  checkSystems: (state) => (system) =>
    state.systems.filter((candidate) => candidate == system).length > 0,
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
